module.exports = __webpack_public_path__ + "img/friends-logo3.aa8acf63.png";